import {Component, OnInit, Input, ViewChild} from 'angular2/core';
import {CampaignService} from "../campaign.service";
import {TranslatePipe, TranslateService} from "ng2-translate";
import {RouteParams, Router} from "angular2/router";
import {AlertService} from "../../common/alerts/alert.service";
import {Select2} from "../../common/select2/basic_select2.component";
import {Country} from "../../../models/country.model";
import {CountryService} from "../../countries/country.service";
import {NgForm} from "angular2/common";
import {CampaignCodesModalComponent} from "./../form/campaign_codes_modal.component";
import {ProductService} from "../../products/product.service";
import {Product} from "../../../models/product.model";
import {AbstractCampaignFormComponent} from "./../form/abstract_form_component";
import {SubmitButtonComponent} from "../../common/submit/submit_button.component";
import {Datepicker} from "../../common/datepicker/datepicker.component";

@Component({
    templateUrl: './app/components/campaigns/form/form.html',
    providers: [CampaignService, CountryService, ProductService],
    directives: [CampaignCodesModalComponent, Select2, SubmitButtonComponent, Datepicker],
    pipes: [TranslatePipe]
})
export class EditCampaignComponent extends AbstractCampaignFormComponent implements OnInit {
    @ViewChild('campaignForm') campaignForm:NgForm;
    @ViewChild('countrySelect') countrySelect;
    @ViewChild('productSelect') productSelect;
    @ViewChild('startDate') startDatePicker;
    @ViewChild('endDate') endDatePicker;
    @ViewChild('submitButton') submitButton;
    minVoucherCount:number;
    countries:Country[];
    products:Product[];

    constructor(protected _params:RouteParams, protected _campaignService:CampaignService, protected _productService:ProductService,
                protected _alert_service:AlertService, protected _router:Router, protected _countryService:CountryService,
                protected _translateService:TranslateService) {
        super(_params, _campaignService, _productService, _alert_service, _router, _translateService);
    }

    ngOnInit() {
        this._campaignService.getCampaign(this._params.get("campaignId")).subscribe(campaign => {
            this.model = campaign;
            this.updateStartDatePicker();
            this.updateEndDatePicker();
            this.minVoucherCount = this.model.hasStarted() ? this.model.voucherCount : 1;
        });

        this._countryService.getCountries().subscribe(countries => {
                this.countries = countries.map((country:Country) => {
                country.name = this._translateService.instant('countries.' + country.iso);
                return country;
             }).sort((a, b) => {
                return (a.name.localeCompare(b.name, window.localStorage.getItem("locale")));
             });
            // Ugly but necessary as I can't bind anything on this affectation:
            //      "this.countries = countries;" //this code reload the <select> in DOM.
            // I need DOM to be up to date before executing the block below, but as it is async and there is now way
            // to subscribe to the affectation/reload event.
            setTimeout(_ =>  this.updateCountrySelect2(), 100);
        });
    }

    onChangeCountry() {
        if (this.model.country === null) {
            this.products = [];
        } else {
            this._productService.getProducts(this.model.country).subscribe(products => {
                this.products = products;
                setTimeout(_ => this.updateProductSelect2(), 1);
            });
        }
    }

    submitCallback() {
        if (! this.campaignForm.valid) {
            console.log('Form is invalid');
            return;
        }
        this.submitButton.toggleSpinner();
        this._campaignService.updateCampaign(this._params.get("campaignId"), this.model).subscribe(a => {
            this.submitButton.toggleSpinner();
            jQuery("#codesModal").modal("toggle");
            this._alert_service.pushAlert({
                type: "success",
                msg: this._translateService.instant("campaigns.update.success"),
                closeable: true
            });
        }, error => {
            this._alert_service.pushAlert({type: "danger", msg: this._translateService.instant(error), closeable: true});
            this.submitButton.toggleSpinner();
        });
    }

    updateProductSelect2() {
        var selectProductEl = jQuery(this.productSelect.valueAccessor._elementRef.nativeElement);
        this.productSelect.viewToModelUpdate(this.model.products);
        selectProductEl.val(this.productSelect.viewModel).trigger("change");
    }

    updateCountrySelect2() {
        this.countrySelect.viewToModelUpdate(this.model.country);
        var selectCountryEl = jQuery(this.countrySelect.valueAccessor._elementRef.nativeElement);
        selectCountryEl.val(this.countrySelect.viewModel).trigger("change");
    }

    updateStartDatePicker() {
        this.startDatePicker.viewToModelUpdate(this.model.startDate);
        var startDatePickerEl = jQuery(this.startDatePicker.valueAccessor._elementRef.nativeElement);
        startDatePickerEl.datepicker("setDate", this.model.startDate);
        startDatePickerEl.val(this.startDatePicker.viewModel).trigger("change");
    }

    updateEndDatePicker() {
        this.endDatePicker.viewToModelUpdate(this.model.endDate);
        var endDatePickerEl = jQuery(this.endDatePicker.valueAccessor._elementRef.nativeElement);
        endDatePickerEl.datepicker("setDate", this.model.endDate);
        endDatePickerEl.val(this.endDatePicker.viewModel).trigger("change");
    }
}
